'use strict';

module.exports = function() {
    var $header = $(document).find('header.cc-header');
    var headerHeight = $header.outerHeight(true);
    var isHeaderTransparent = $header.data('header');
    var prevScrollpos = window.pageYOffset;

    $(window).scroll(function() {
        var currentScrollPos = window.pageYOffset;

        // if scrolling down, let it scroll out of view as normal
        if (prevScrollpos < currentScrollPos && currentScrollPos > headerHeight) {
            $header.addClass('cc-header--collapsed');
            if ($('.cc-headerSearch').hasClass('cc-headerSearch--open')) {
                $(document).find('.js-headerSearch').removeClass('cc-headerSearch--open');
                $(document).find('.js-headerOverlay').removeClass('cc-header__overlay--active');
            }
        } else {
            // otherwise if we're scrolling up, fix the nav to the top
            $header.removeClass('cc-header--collapsed');
            if ($('.cc-headerSearch').hasClass('cc-headerSearch--open')) {
                $(document).find('.js-headerSearch').removeClass('cc-headerSearch--open');
                $(document).find('.js-headerOverlay').removeClass('cc-header__overlay--active');
            }
        }

        if (isHeaderTransparent) {
            if (currentScrollPos < headerHeight) {
                $header.addClass('cc-header--transparent');
            } else {
                if (prevScrollpos > currentScrollPos) {
                    $header.removeClass('cc-header--transparent');
                }
            }
        }

        prevScrollpos = currentScrollPos;
    });
};
